import { ref, onMounted, onUnmounted } from 'vue'

/**
 * Composable para detectar inactividad del usuario
 * @param {number} inactivityTime - Tiempo de inactividad en milisegundos (default: 60 minutos)
 * @returns {Object} - { showModal, startTimer, stopTimer, resetTimer, closeModal }
 */
export default function useInactivityDetector(inactivityTime = 60 * 60 * 1000) {
  const showModal = ref(false)
  
  let inactivityTimer = null
  const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click']

  /**
   * Resetea el timer de inactividad
   */
  const resetTimer = () => {
    clearTimeout(inactivityTimer)
    startTimer()
  }

  /**
   * Inicia el timer de inactividad
   */
  const startTimer = () => {
    // Limpiar cualquier timer anterior antes de iniciar uno nuevo
    clearTimeout(inactivityTimer)
    
    inactivityTimer = setTimeout(() => {
      showModal.value = true
    }, inactivityTime)
  }

  /**
   * Detiene el timer de inactividad
   */
  const stopTimer = () => {
    clearTimeout(inactivityTimer)
  }

  /**
   * Cierra el modal de inactividad
   */
  const closeModal = () => {
    showModal.value = false
  }

  /**
   * Agregar listeners de eventos
   */
  const addEventListeners = () => {
    events.forEach(event => {
      window.addEventListener(event, resetTimer)
    })
  }

  /**
   * Remover listeners de eventos
   */
  const removeEventListeners = () => {
    events.forEach(event => {
      window.removeEventListener(event, resetTimer)
    })
  }

  // Inicializar al montar - solo agregamos los listeners
  // El timer se controla desde App.vue mediante el watch de rutas
  onMounted(() => {
    addEventListeners()
  })

  // Limpiar al desmontar
  onUnmounted(() => {
    removeEventListeners()
    stopTimer()
  })

  return {
    showModal,
    startTimer,
    stopTimer,
    resetTimer,
    closeModal
  }
}

